export default "__VITE_ASSET__CbhRNHUd__"